'use client';

import { motion, type HTMLMotionProps } from 'framer-motion';

interface SubtleEntranceProps
  extends Omit<
    HTMLMotionProps<'div'>,
    'initial' | 'animate' | 'whileInView' | 'viewport' | 'transition'
  > {
  delay?: number;
  children: React.ReactNode;
  /** If true, animates on mount instead of when in view */
  animateOnMount?: boolean;
}

export const SubtleEntrance = ({
  delay = 0,
  children,
  animateOnMount = false,
  ...props
}: SubtleEntranceProps) => {
  const animationProps = animateOnMount
    ? {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
    }
    : {
      initial: { opacity: 0 },
      whileInView: { opacity: 1 },
      viewport: { once: true },
    };

  return (
    <motion.div
      {...animationProps}
      transition={{ duration: 0.8, delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
